import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    data: {},
    loading: {},
    error: {},
};

const dataSlice = createSlice({
    name: 'data',
    initialState,
    reducers: {
        fetchStart: (state, action) => {
            const { key } = action.payload;
            state.loading[key] = true;
            state.error[key] = null;
        },
        fetchSuccess: (state, action) => {
            const { key, data } = action.payload;
            state.data[key] = data;
            state.loading[key] = false;
            state.error[key] = null;
        },
        fetchError: (state, action) => {
            const { key, error } = action.payload;
            state.loading[key] = false;
            state.error[key] = error;
        },
        clearData: (state, action) => {
            const { key } = action.payload;
            if (key) {
                delete state.data[key];
                delete state.loading[key];
                delete state.error[key];
            } else {
                return { ...initialState };
            }
        },
    },
});

export const { fetchStart, fetchSuccess, fetchError, clearData } = dataSlice.actions;
export default dataSlice.reducer;
